import { LinkIcon } from '@chakra-ui/icons';
import { Button, Flex, Link, Stack } from '@chakra-ui/react';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DataTable } from '../../components/Table/DataTable';
import useChainsQuery from '../../hooks/useChainsQuery';
import { ContentCard } from '../../layout/ContentCard';

const initialFilters = {
  searchString: '',
  itemsPerPage: 20,
};

const ChainsOverviewCard = () => {
  const { t } = useTranslation();

  const localStorageData = window.localStorage.getItem('chains_filters');
  // @ts-ignore
  const destringifiedData = JSON.parse(localStorageData) || {};
  useEffect(() => {
    if (!localStorageData) {
      window.localStorage.setItem('chains_filters', JSON.stringify(initialFilters));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [searchString, setSearchString] = useState(destringifiedData?.searchString || initialFilters?.searchString);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(destringifiedData?.itemsPerPage || initialFilters?.itemsPerPage);

  const chainsQuery = useChainsQuery(searchString, itemsPerPage, page);

  // @ts-ignore
  const currentPage = chainsQuery.data?.current_page - 1;

  const initialLoad = searchString === '' && itemsPerPage === 20 && page === 1;

  useEffect(() => {
    setPage(1);
  }, [searchString, itemsPerPage]);
  // @ts-ignore
  const chains = chainsQuery.data?.data || [];

  const columns = useMemo(
    () => [
      {
        Header: t('pages:config_forms.table.columns.name'),
        accessor: 'name',
      },
      {
        Header: t('forms:country.label'),
        accessor: (row: any) => t(`location:countries.${row.country}`),
      },
      {
        Header: t('workshop:language.label'),
        accessor: (row: any) => t(`location:languages.${row.language}`),
      },
      {
        accessor: 'id',
        Cell: (cellProps: { row: any }) => {
          const { row } = cellProps;
          return (
            <Flex alignContent={'flex-end'}>
              <Button ml={'auto'}>
                <Link href={`/app/op/chains/${row.original.id}`}>{t('common:details')}</Link>
              </Button>
            </Flex>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [chains, searchString, itemsPerPage, page],
  );

  return (
    <ContentCard
      icon={<LinkIcon boxSize={10} />}
      minH="fit-content"
      header={t('pages:chains.meta.title')}
      contentDescription={t('pages:chains.create.description')}
      data-test-id="chains-overview-card"
    >
      <Button variant={'primary'} width="min-content">
        <Link href={'/app/op/chains/create'}>{t('pages:chains.create.title')}</Link>
      </Button>
      <Stack direction={['column', 'row']} w={'100%'}>
        <Stack direction="column" w={'100%'}>
          <DataTable
            resetFilter={() => {
              setSearchString(initialFilters?.searchString);
              setPage(1);
              setItemsPerPage(initialFilters?.itemsPerPage);
            }}
            globalFilter={searchString}
            autoFocus={true}
            // @ts-ignore
            setGlobalFilter={setSearchString}
            globalFilterPlaceholder={t('chains_filters:search')}
            // @ts-ignore
            hasFilters={false}
            hasSearchInput={true}
            currentPage={currentPage}
            perPage={itemsPerPage}
            data-test-id="chains-table"
            data={chains || []}
            // @ts-ignore
            total={chainsQuery.data?.last_page || 1}
            setPage={setPage}
            setPerPage={setItemsPerPage}
            isMoreThenOnePage={
              // @ts-ignore
              !initialLoad || Boolean(chainsQuery.data?.next_page_url) || currentPage > 0
            }
            columns={columns}
            loading={chainsQuery.isFetching || chainsQuery.isLoading}
          />
        </Stack>
      </Stack>
    </ContentCard>
  );
};

export default ChainsOverviewCard;
